<template>
  <div class="px-2">
    <div class="widget-12 card card-default widget-loader-circle shade">
      <div class="card-body">
        <div class="row">
          <div class="col-md-9 col-sm-12" data-v-step="7">
            <line-chart-component
              title="Tren Mention, Reach dan Engagement"
              :subTitle="chart_subtitle"
              :data="data"
            />
          </div>
          <div class="col-md-3 col-sm-12 visible-md p-l-15" data-v-step="8">
            <sources-list-component
              :key="sources_key_child"
              title="Sources"
              subTitle="Menampilkan Jumlah Mention Per Sumber"
              :lists="source"
              :isLoading="isLoading2"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import line_chart_dual_axis from "@/views/components/chart/line_chart_dual_axis.vue";
import source_list from "@/views/components/source_list.vue";
import moment from "moment";

var icon_sources = [];
icon_sources["facebook"] = "bi bi-facebook";
icon_sources["twitter"] = "bi bi-twitter";
icon_sources["instagram"] = "bi bi-instagram";
icon_sources["youtube"] = "bi bi-youtube";
icon_sources["tiktok"] = "bi bi-tiktok";
icon_sources["linkedin"] = "bi bi-linkedin";
icon_sources["news"] = "bi bi-newspaper";
icon_sources["blog"] = "bi bi-rss";
icon_sources["forum"] = "bi bi-chat-dots-fill";
icon_sources["review"] = "bi bi-phone";

export default {
  name: "medsos_tren_mention",
  props: {
    data_line_chart: Object,
    data_source: Array,
    isLoading: {
      type: Boolean,
      default: function () {
        return true;
      },
    },
  },
  components: {
    "line-chart-component": line_chart_dual_axis,
    "sources-list-component": source_list,
  },
  data() {
    return {
      sources: null,
      data: this.data_line_chart,
      sources_key_child: 0,
      isLoading2: true,
      chart_subtitle: "Menampilkan grafik jumlah mention dan reach perhari",
      active_source: this.$store.getters.user.project.project_detail.crawler,
    };
  },
  methods: {
    setDataSources: function () {
      this.source = [];
      if (this.data_source != null) {
        let total_sources = this.arraySum();
        let dalam_kurung = 0;
        let source = {};
        if (this.active_source.facebook.status == 1) {
          dalam_kurung =
            total_sources > 0
              ? (this.data_source.facebook / total_sources) * 100
              : 0;
          source = {
            icon: icon_sources["facebook"],
            name: this.capitalizeWords("facebook"),
            count: this.data_source["facebook"]
              ? this.data_source["facebook"]
              : 0,
            dalam_kurung: dalam_kurung.toFixed(2) + "%",
          };
          this.source.push(source);
        }
        if (this.active_source.tiktok.status == 1) {
          dalam_kurung =
            total_sources > 0
              ? (this.data_source.tiktok / total_sources) * 100
              : 0;
          source = {
            icon: icon_sources["tiktok"],
            name: this.capitalizeWords("tiktok"),
            count: this.data_source["tiktok"] ? this.data_source["tiktok"] : 0,
            dalam_kurung: dalam_kurung.toFixed(2) + "%",
          };
          this.source.push(source);
        }
        if (this.active_source.twitter.status == 1) {
          dalam_kurung =
            total_sources > 0
              ? (this.data_source.twitter / total_sources) * 100
              : 0;
          source = {
            icon: icon_sources["twitter"],
            name: this.capitalizeWords("twitter"),
            count: this.data_source["twitter"]
              ? this.data_source["twitter"]
              : 0,
            dalam_kurung: dalam_kurung.toFixed(2) + "%",
          };
          this.source.push(source);
        }
        if (this.active_source.youtube.status == 1) {
          dalam_kurung =
            total_sources > 0
              ? (this.data_source.youtube / total_sources) * 100
              : 0;
          source = {
            icon: icon_sources["youtube"],
            name: this.capitalizeWords("youtube"),
            count: this.data_source["youtube"]
              ? this.data_source["youtube"]
              : 0,
            dalam_kurung: dalam_kurung.toFixed(2) + "%",
          };
          this.source.push(source);
        }
        if (this.active_source.linkedin.status == 1) {
          dalam_kurung =
            total_sources > 0
              ? (this.data_source.linkedin / total_sources) * 100
              : 0;
          source = {
            icon: icon_sources["linkedin"],
            name: this.capitalizeWords("linkedin"),
            count: this.data_source["linkedin"]
              ? this.data_source["linkedin"]
              : 0,
            dalam_kurung: dalam_kurung.toFixed(2) + "%",
          };
          this.source.push(source);
        }
        if (this.active_source.instagram.status == 1) {
          dalam_kurung =
            total_sources > 0
              ? (this.data_source.instagram / total_sources) * 100
              : 0;
          source = {
            icon: icon_sources["instagram"],
            name: this.capitalizeWords("instagram"),
            count: this.data_source["instagram"]
              ? this.data_source["instagram"]
              : 0,
            dalam_kurung: dalam_kurung.toFixed(2) + "%",
          };
          this.source.push(source);
        }
        if (this.active_source.google.blog_status == 1) {
          dalam_kurung =
            total_sources > 0
              ? (this.data_source.blog / total_sources) * 100
              : 0;
          source = {
            icon: icon_sources["blog"],
            name: this.capitalizeWords("blog"),
            count: this.data_source["blog"] ? this.data_source["blog"] : 0,
            dalam_kurung: dalam_kurung.toFixed(2) + "%",
          };
          this.source.push(source);
        }
        if (this.active_source.google.forum_status == 1) {
          dalam_kurung =
            total_sources > 0
              ? (this.data_source.forum / total_sources) * 100
              : 0;
          source = {
            icon: icon_sources["forum"],
            name: this.capitalizeWords("forum"),
            count: this.data_source["forum"] ? this.data_source["forum"] : 0,
            dalam_kurung: dalam_kurung.toFixed(2) + "%",
          };
          this.source.push(source);
        }
        if (this.active_source.google.news_status == 1) {
          dalam_kurung =
            total_sources > 0
              ? (this.data_source.news / total_sources) * 100
              : 0;
          source = {
            icon: icon_sources["news"],
            name: this.capitalizeWords("Online News"),
            count: this.data_source["news"] ? this.data_source["news"] : 0,
            dalam_kurung: dalam_kurung.toFixed(2) + "%",
          };
          this.source.push(source);
        }
        if (
          "review" in this.active_source &&
          this.active_source.review.status == 1
        ) {
          dalam_kurung =
            total_sources > 0
              ? (this.data_source.review / total_sources) * 100
              : 0;
          source = {
            icon: icon_sources["review"],
            name: this.capitalizeWords("Review Aplikasi"),
            count: this.data_source["review"] ? this.data_source["review"] : 0,
            dalam_kurung: dalam_kurung.toFixed(2) + "%",
          };
          this.source.push(source);
        }
        this.isLoading2 = false;
        this.sources_key++;
      }
    },
    arraySum: function () {
      let total = 0;
      for (let key in this.data_source) {
        total += this.data_source[key];
      }
      return total;
    },
    capitalizeWords: function (str) {
      return str.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    },
    assembleSource: function (name, persentase) {
      let source = {
        name: name,
        count: this.resp.stats[name.toLowerCase()],
        dalam_kurung: persentase,
      };
      return source;
    },
    setSubtitle: function () {
      if ("from" in this.$route.query && "to" in this.$route.query) {
        let from = moment(this.$route.query.from, "YYYY-MM-DD HH:mm:ss");
        let to = moment(this.$route.query.to, "YYYY-MM-DD HH:mm:ss");
        var duration = moment.duration(to.diff(from));
        var hours = duration.asHours();
        if (hours > 24) {
          this.chart_subtitle =
            "Menampilkan Grafik Mention, Reach dan Engagement Per Hari";
        } else {
          this.chart_subtitle =
            "Menampilkan Grafik Mention, Reach dan Engagement Per Jam";
        }
      } else {
        this.chart_subtitle =
          "Menampilkan Grafik Mention, Reach, dan Engagement Per Hari";
      }
    },
  },
  created: function () {
    this.setDataSources();
  },
  mounted: function () {
    this.setSubtitle();
  },
};
</script>